import React, { useState } from 'react';
import ButtonPrimary from 'src/elements/buttons/Button.primary';
import Paragraph from 'src/elements/typography/paragraph';
import { navigateToCohost } from 'src/functions/communityNameGenerator/navigateToCohost';
import { palette } from 'src/styles/colors';
import { IdealMembersInputSmallContainer, InputWrapper, Input } from './IdealMembersInputSmall.styles';

interface IdealMembersInputSmallProps {
  generationMode: string;
  mobileText?: string;
  statsigEvent?: string;
  inlineButtonOnMobile?: boolean;
}

const IdealMembersInputSmall = ({
  generationMode,
  statsigEvent,
  mobileText = 'Suggest a Community',
  inlineButtonOnMobile = false,
}: IdealMembersInputSmallProps): JSX.Element => {
  const [idealMember, setIdealMember] = useState<string>('');
  const [inputError, setInputError] = useState<string>(null);

  const handleIdealMemberSubmit = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (idealMember?.length > 60) {
      setInputError('Must be less than 60 characters');
    } else if (idealMember?.length <= 3) {
      setInputError('Please enter more about who you want to bring together');
    } else {
      setInputError(null);

      navigateToCohost({
        idealMember,
        event,
        statsigEvent,
        mode: generationMode,
        sectionLabel: `${generationMode}-bottom`,
      });
    }
  };

  const handleInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleIdealMemberSubmit(event as unknown as React.MouseEvent<HTMLButtonElement, MouseEvent>);
    }
  };

  const renderGoButton = (text: string) => (
    <ButtonPrimary
      text={text}
      colorScheme='AccentBlue'
      onClick={handleIdealMemberSubmit}
    />
  );

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => setIdealMember(event.target.value);

  return (
    <IdealMembersInputSmallContainer className='ideal-member-container'>
      {inputError && (
        <Paragraph
          text={inputError}
          size='.8rem'
          align='left'
          color={palette.softRed}
          weight='light'
        />
      )}
      <InputWrapper
        className='ideal-member-input'
        inlineButtonOnMobile={inlineButtonOnMobile}
      >
        <Input
          onChange={handleInputChange}
          type='text'
          name='idealMember'
          value={idealMember}
          maxLength={60}
          onKeyDown={handleInputKeyDown}
        />

        {/* Hide on mobile */}
        {renderGoButton('Go')}
      </InputWrapper>

      {/* Show on mobile */}
      {!inlineButtonOnMobile && renderGoButton(mobileText)}
    </IdealMembersInputSmallContainer>
  );
};

export default IdealMembersInputSmall;

